import classNames from 'classnames'
import React, {useContext, useEffect, useRef, useState} from 'react'
import {BsDiamondFill, BsFacebook, BsYoutube} from 'react-icons/bs'
import ReactPlayer from 'react-player'
import useToggle from 'react-use/lib/useToggle'
import {FB_ID} from '../../envs/_current/config'
import {LayoutContext} from '../layouts/Default/LayoutContext'
import {renderIf} from "../../views/Shared";
import Ahref from "../Ahref";

let currentPlayerRefs = {
    current: {
        setPlaying: undefined,
    },
}

export const MediaPlayer = React.memo(({ url, host_name, image, ...props }) => {
    const { isSm } = useContext(LayoutContext);
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(400);
    const [playing, setPlaying] = useState(false);

    useEffect(() => {
        if (currentPlayerRefs.current.setPlaying) {
            currentPlayerRefs.current.setPlaying(false);
        }
        currentPlayerRefs.current.setPlaying = setPlaying;
        setPlaying(true);

        return () => {
            currentPlayerRefs.current.setPlaying = undefined;
        };
    }, []); // ✅ chỉ chạy 1 lần khi mount

    useEffect(() => {
        if (containerRef.current) {
            setContainerWidth(containerRef.current.offsetWidth);
        }
    }, []);

    return (
        <div ref={containerRef} className="w-full">
            <ReactPlayer
                key={url}
                width="100%"
                height={containerWidth * 9 / 16}
                url={url}
                playing={playing}
                light={host_name === "facebook.com" && image ? image : true}
                config={{
                    youtube: {
                        playerVars: { controls: 1, autoplay: 1, showinfo: 1 },
                    },
                    facebook: { appId: FB_ID },
                }}
                {...props}
            />
        </div>
    );
});

export function VideoEmbed({
                               style,
                               title,
                               subTitle,
                               className,
                               url,
                               description,
                               image,
                               categories = [],
                               isShowPlayer = false,
                               host_name,
                               ...props
                           }) {
    const {isSm} = useContext(LayoutContext)
    const [showPlayer, toggleShowPlayer] = useToggle(isShowPlayer)

    let hostLabel, hostIcon;
    switch (subTitle) {
        case 'facebook.com':
            hostLabel = "Facebook";
            hostIcon = <BsFacebook size={16} className="text-blue-600"/>;
            break;
        case 'youtube.com':
            hostLabel = "Youtube";
            hostIcon = <BsYoutube size={16} className="text-primary"/>;
            break;
        default:
            hostLabel = subTitle
            hostIcon = <BsYoutube size={16} className="text-color-400"/>;
            break;
    }

    return (
        <div style={style} className={classNames('border rounded-lg VideoEmbed', className)}>
            <MediaPlayer url={url} host_name={host_name} image={image} {...props}/>
            <div className="p-2 rounded-b-lg flex flex-col gap-2 flex-1 overflow-hidden">
                {renderIf(
                    subTitle,
                    <div className="flex items-center gap-2">
                        {hostIcon}
                        <Ahref
                            href={'https://' + subTitle}
                            target="_blank"
                            rel="noopener noreferrer nofollow"
                            style={{fontSize: 13, textDecoration: 'none'}}
                            className="flex-1 font-bold text-blue-700 tracking-wider leading-tight truncate">
                            {hostLabel}
                        </Ahref>
                    </div>
                )}
                {!!title && (
                    <Ahref
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                        className="font-bold text-color-000 text-base leading-tight no-underline max-lines-2">
                        {title}
                    </Ahref>
                )}
                {!!description && (
                    <div className="text-doc-sm text-color-300 tracking-wider max-lines-2 leading-snug">
                        {description}
                    </div>
                )}
                {!!categories && !!categories.length && (
                    <div className="text-xs">
                        {categories.map((e) => (
                            <span key={e.id} className="flex items-center font-medium text-primary italic">
                                <BsDiamondFill size={6} className="mr-2"/>
                                {e.name}
                            </span>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}
